<template>
    <div id="nav" class="h-100 bg-secondary" :class="headerClass">
        <div id="nav-logo" @click="navCollapsed = !navCollapsed" class="bg-primary">
            <img src="/farmlink-logo.png" class="py-2" />
        </div>
        <div class="d-flex flex-column align-items-end pt-2 pb-4">
            <nav-item :to="'/'" :icon="'tachometer-alt-slow'">
                {{ $t('labels.nav.dashboard') }}
            </nav-item>
            <nav-item :to="'/all-bookings/calendar'" :icon="'calendar-alt'">
                {{ $t('labels.nav.all_bookings') }}
            </nav-item>
            <nav-item :to="'/lists'" :icon="'clipboard-list'">
                {{ $tc('labels.list', 0) }}
            </nav-item>
            <nav-item :to="'/projects'" :icon="'drafting-compass'">
                {{ $tc('labels.project', 0) }}
            </nav-item>
            <nav-item :to="'/customers'" :icon="'address-book'">
                {{ $t('labels.nav.customers') }}
            </nav-item>
            <nav-item :to="'/tasks'" :icon="'tasks'">
                {{ $t('labels.nav.tasks') }}
            </nav-item>
            <nav-item :to="'/vehicles'" :icon="'truck-pickup'">
              {{ $t('labels.nav.vehicles') }}
            </nav-item>
            <nav-item :to="'/settings'" :icon="'cogs'" v-if="auth.can['settings']">
                {{ $t('labels.nav.settings') }}
            </nav-item>
        </div>
        <div class="position-absolute nav-chevron text-light clickable" @click="navCollapsed = !navCollapsed">
            <fa-icon :icon="['fal', 'chevron-double-left']" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      navHidden: true,
      navCollapsed: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.navHidden = false
    }, 100)
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    headerClass () {
      let cl = ''
      if (this.navHidden) cl += 'hidden '
      if (this.navCollapsed) cl += 'collapsed '
      return cl
    }
  }
}
</script>

<style lang="scss">

    #nav {
        position: fixed;
        top: 0;
        bottom: 0;
        width: 240px;
        transition: 0.2s ease-out width;
        padding-top: 50px;

        #nav-logo {
            position: absolute;
            width: 240px;
            top: 0;
            height: 50px;
            cursor: pointer;
            overflow: hidden;
            transition: 0.2s ease-out width;

            img {
                transition: 0.2s ease-out right;
                position: absolute;
                height: 40px;
                top: 5px;
                right: 0;
            }
        }

        a {
            height: 40px;
            white-space: nowrap;
        }

        .nav-chevron {
            bottom: 0;
            right: 0;
            line-height: 50px;
            width: 50px;
            text-align: center;
        }

        &.collapsed {
            width: 0;

            #nav-logo {
                width: 40px;

                img {
                    right: -67px;
                }
            }

            a span {
                display: none;
            }

            .nav-chevron {
                transform: rotate(180deg);
            }
        }
    }

    @media(min-width: 768px) {
        #nav {
            position: relative;
            padding-top: 0;

            #nav-logo {
                position: relative;
                left: auto;
                overflow: visible;
            }

            &.collapsed {
                width: 50px;

                #nav-logo {
                    width: 50px;

                    img {
                        right: -75px;
                    }
                }
            }

            &.hidden {
                width: 0;
                overflow: hidden;
            }
        }
    }
</style>
